import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { digitalMarketingModasaConfig } from './servicePageConfigs';

const ServiceDigitalModasa = () => <ServicePageTemplate {...digitalMarketingModasaConfig} />;

export default ServiceDigitalModasa;
